import React, { useContext } from "react";

import { Grid } from "@mui/material";
import { Link } from "react-router-dom";
import Classes from "./MainpageBtn.module.css";

import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import idea from "../../img/idea.svg";
import milestone from "../../img/milestone.svg";
import profile from "../../img/profile.svg";
import teamformation from "../../img/teamformation.svg";
import { RootStoreContext } from "./../../store";
// import CircularProgress from "@mui/material/CircularProgress";
import locker from "../../img/locker.svg";
import { teamIdList } from "../../services/TeamService";

function MainpageChoiceBtnGroup({ btnList, leftTeam }) {
  // const [hasCEO, setHasCEO] = useState(false);
  const imgList = [profile, teamformation];
  const [teamIds, setTeamIds] = useState([]);
  const NameList = ["個人檔案", "組建團隊"];
  const history = useHistory();
  const { MilestoneDetailStore, LoginStore, MilestoneStore, PersonalStore } =
    useContext(RootStoreContext);
  const { getTeamId, teamId, checkCEO, hasCEO, init } = MilestoneDetailStore;
  const { updateData } = MilestoneStore;
  const { user } = LoginStore;
  const { teamid } = PersonalStore;
  useEffect(() => {
    getTeamId(user.uid);
    checkCEO(user.uid);
  }, [teamId, user.uid, checkCEO, leftTeam]);

  useEffect(() => {
    teamIdList()
      .then((value) => {
        setTeamIds(value);
      })
      .catch(console.log);

  }, []);

  return (
    <Grid container className={Classes.Outter}>
      <Grid item md={2} />
      <Grid item xs={12} md={2} className={Classes.MainpageBtnOutter}>
        <div
          variant="h8"
          className={Classes.link}
          // style={{ pointerEvents: (!hasCEO || leftTeam) && "none" }}
          onClick={() => {
            history.push("/ideapool");
          }}
        >
          <img src={idea} alt="" className={Classes.MainpageBtn2} />
        </div>
        <div className={Classes.MainpageBtnTxt}>點子池</div>
      </Grid>
      {btnList.map((text, index) => {
        let url = text;
        if (text === "Teamformation" && (teamIds.includes(teamid))) {
          url = "team-1";
        }
        return (
          <Grid item xs={12} md={2} className={Classes.MainpageBtnOutter}>
            <Link to={"/" + url} className={Classes.link}>
              {/* <div
              variant="h8"
              key={`${text}-${index}`}
              className={Classes.MainpageBtn}
            > */}
              <img src={imgList[index]} alt="" className={Classes.MainpageBtn} />
              {/* </div> */}
            </Link>
            <div className={Classes.MainpageBtnTxt}>{NameList[index]}</div>
          </Grid>
        );
      })}
      <Grid item xs={12} md={2} className={Classes.MainpageBtnOutter}>
        <div
          variant="h8"
          className={Classes.link}
          style={{ pointerEvents: (!hasCEO || leftTeam) && "none" }}
          onClick={() => {
            // updateData("currentPlanIndex", "");
            if (hasCEO && !leftTeam) {
              history.push("/Milestone");
            } else {
              // alert("請先創建團隊");
            }
          }}
        >
          {/* {fetching ? (
            <CircularProgress />
          ) : ( */}
          <img src={milestone} alt="" className={Classes.MainpageBtn} />
          {/* )} */}
        </div>
        <div>
          {hasCEO && !leftTeam ? (
            <div className={Classes.MainpageBtnTxt}>壓力測試</div>
          ) : (
            <img className={Classes.lockerimg} src={locker} alt="mainpage" />
          )}
        </div>
      </Grid>
      <Grid item md={2} />
    </Grid>
  );
}

export default observer(MainpageChoiceBtnGroup);
